import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { http } from "@/lib/api";
import { toast } from "sonner";
import { Users, ArrowRight, Sparkle } from "@phosphor-icons/react";

export default function ResearchRequestsHub() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    http.get("/experts/research-requests", { params: { limit: 40 } })
      .then(({ data }) => setRows(data.requests || []))
      .catch(() => toast.error("Could not load research requests"))
      .finally(() => setLoading(false));
  }, []);

  return (
    <main className="bg-[#F5EBDC] min-h-screen pt-32 md:pt-36 pb-32 px-5 md:px-10" data-testid="research-requests-page">
      <div className="max-w-[1100px] mx-auto">
        <div className="font-mono-tech text-[10px] tracking-[0.32em] uppercase text-[color:var(--np-brand,#B85F2A)]">/ Research requests</div>
        <h1 className="mt-2 font-serif-display text-4xl md:text-6xl leading-[0.98] tracking-tight">Help scientists collect what they can't reach on their own.</h1>
        <p className="mt-3 max-w-3xl font-serif-display text-base md:text-lg italic text-[#3A3830]">
          NaturePulse Experts post research requests here. Your observations, photos and field notes fill in the map so the community answers questions that would take one researcher decades alone.
        </p>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-4">
          {loading && Array.from({ length: 4 }).map((_, i) => <div key={i} className="rounded-2xl border border-black/10 bg-white/60 h-40 animate-pulse" />)}
          {!loading && rows.length === 0 && <div className="text-sm text-[#3A3830]">No active research requests yet.</div>}
          {rows.map((r) => (
            <div key={r.id} data-testid={`research-request-${r.id}`} className="rounded-2xl bg-white border border-black/10 p-5 hover:border-[color:var(--np-brand,#B85F2A)] transition">
              <div className="font-mono-tech text-[10px] tracking-[0.28em] uppercase text-[color:var(--np-brand,#B85F2A)] flex items-center gap-1">
                <Users size={11} weight="fill" /> {r.expert_name}
              </div>
              <h2 className="mt-1 font-serif-display text-xl leading-tight">{r.title}</h2>
              <p className="mt-2 text-sm text-[#3A3830] line-clamp-3">{r.body}</p>
              {r.topics?.length > 0 && (
                <div className="mt-2 flex flex-wrap gap-1.5">
                  {r.topics.slice(0, 4).map((t) => (
                    <span key={t} className="rounded-full bg-[#FBF2E1] border border-black/10 px-2 py-0.5 font-mono-tech text-[9px] tracking-[0.22em] uppercase">{t}</span>
                  ))}
                </div>
              )}
              <div className="mt-4 flex items-center justify-between">
                <Link to={`/expert/${r.expert_slug}`} className="font-mono-tech text-[10px] tracking-[0.24em] uppercase underline decoration-dotted underline-offset-2">by {r.expert_name}</Link>
                <Link to="/stories/new" className="inline-flex items-center gap-1 rounded-full bg-[#1B4332] text-[#F5EBDC] px-3 py-1.5 font-mono-tech text-[10px] tracking-[0.28em] uppercase hover:opacity-90">
                  <Sparkle size={11} weight="fill" /> Contribute <ArrowRight size={10} weight="bold" />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </main>
  );
}
